const { REACT_APP_PRODUCT_FRUITS_ID } = process.env;

interface ConfiguracaoDoFruits {
  fruitsId: string | undefined;
}

export const fruitsConfig: ConfiguracaoDoFruits = {
  fruitsId: REACT_APP_PRODUCT_FRUITS_ID || undefined,
};
